module.exports = __webpack_public_path__ + "media/images/no-ref-c68b2101f7961a24d06cda8d669691ac.png";